// extracted by mini-css-extract-plugin
module.exports = {"secondary-blue":"#5bc0de","secondary-blue-interaction":"#51aac4","secondary-blue-disabled":"#b4e0ef","secondaryButton":"SecondaryButton_secondaryButton__3ZopC"};